// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PageTitle = require("../../../reason/common/PageTitle.bs.js");
let GreatBrowsers = require("../../../components/GreatBrowsers/GreatBrowsers.bs.js");
let MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let UnsupportedBrowserLogoSvg = require("./images/unsupported-browser-logo.svg");

let unsupportedBrowserLogo = UnsupportedBrowserLogoSvg;

function BrowserWarningPage(props) {
  return JsxRuntime.jsxs(MarkupHelpers.Container.make, {
    children: [
      JsxRuntime.jsx(PageTitle.make, {
        title: "Upgrade Your Browser"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "block w-[148px]",
            alt: "",
            src: unsupportedBrowserLogo
          }),
          JsxRuntime.jsx("h2", {
            children: "Upgrade your browser to use Top Agent Network",
            className: "\n          text-center font-light text-zinc-800 \n          text-[26px] md:text-[36px] lg:text-[42px] leading-[1.25] \n          mt-[20px] sm:mt-[20px] lg:mt-[25px] xl:mt-[30px] \n          mb-[40px] sm:mb-[40px] md:mb-[50px] lg:mb-[60px]"
          }),
          JsxRuntime.jsx("div", {
            children: "We built Top Agent Network using the latest technology, which makes TAN faster and easier to use. Your current browser doesn't support these technologies.",
            className: "w-full text-zinc-800 text-[20px] md:text-[24px] leading-[1.5] text-center font-light"
          })
        ],
        className: "py-[30px] flex flex-col items-center max-w-[800px] mx-auto md:mb-[50px]"
      }),
      JsxRuntime.jsx(GreatBrowsers.make, {})
    ]
  });
}

let make = BrowserWarningPage;

let $$default = BrowserWarningPage;

exports.unsupportedBrowserLogo = unsupportedBrowserLogo;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* unsupportedBrowserLogo Not a pure module */
